<!--
  ~ Copyright (c) 2023 NEXTWELL INTL SRL. All Rights Reserved.
  ~ This software is the proprietary information of NEXTWELL INTL SRL.
  ~ Use is subject to license and non-disclosure terms
  -->

<div [ngClass]="class">
  <p-datePicker
    [dateFormat]="displayDateFormat"
    [locale]="locale"
    [(ngModel)]="startDate"
    [style]="calendarStyle"
    [showButtonBar]="showButtonBar"
    [yearRange]="yearRange ? yearRange : '1900:2030'"
    [showClear]="showClear"
    [disabled]="disabled"
    [ngClass]="{ 'ng-invalid': invalid, 'ng-valid': !invalid, 'ng-dirty': dirty }"
    [keepInvalid]="true"
    [minDate]="minimumDay"
    [maxDate]="maximumDay"
    (onSelect)="onChangeStart($event)"
    (onClearClick)="onClear('start')"
    (onClear)="onClear('start')"
    appendTo="{{ this.appendTo }}"
    placeholder="{{ 'sharedComponents.dateRange.start' | translate }}"
   data-testid="start-date-datepicker">
  </p-datePicker>
  <p-datePicker
    [dateFormat]="displayDateFormat"
    [locale]="locale"
    [style]="calendarStyle"
    [showButtonBar]="showButtonBar"
    [showClear]="showClear"
    [yearRange]="yearRange ? yearRange : '1900:2030'"
    [(ngModel)]="endDate"
    [disabled]="disabled"
    [ngClass]="{ 'ng-invalid': invalid, 'ng-valid': !invalid, 'ng-dirty': dirty }"
    [keepInvalid]="true"
    [minDate]="minimumDay"
    [maxDate]="maximumDay"
    (onSelect)="onChangeEnd($event)"
    (onClearClick)="onClear('end')"
    (onClear)="onClear('end')"
    appendTo="{{ this.appendTo }}"
    placeholder="{{ 'sharedComponents.dateRange.end' | translate }}"
   data-testid="end-date-datepicker">
  </p-datePicker>
</div>
